module.exports = __webpack_public_path__ + "img/card.e06b4468.png";